export const DOCUMENT_UPLOAD = "DOCUMENT_UPLOAD";
export const DOCUMENT_UPLOAD_SUCCESS = 'DOCUMENT_UPLOAD_SUCCESS';


export const SET_DEFAULT_BANK = "SET_DEFAULT_BANK";
export const SET_DEFAULT_BANK_SUCCESS = 'SET_DEFAULT_BANK_SUCCESS';